@if (geschaeft) {
  <cap-content-header>
    <cap-title>
      <span
        >{{ "GrundbuchmeldungZuTagebuch" | translate }}:
        <span>{{ geschaeft?.timePoint.geschaeftsnummer | formatGeschaeftsnummer }}</span>
      </span>
    </cap-title>
    <cap-title-functionbar>
      <div class="inline-form float-end">
        <div class="float-end btn-group btn-group-sm">
          <cap-auszug [item]="geschaeft"></cap-auszug>
        </div>
      </div>
    </cap-title-functionbar>
  </cap-content-header>
}

@if (geschaeft) {
  <div class="mt-2 detail-form">
    <cap-details-grundbuchgeschaeft [geschaeft]="geschaeft"></cap-details-grundbuchgeschaeft>
    <cap-vertragsdaten
      [referenzObjectArt]="'GRUNDBUCHMELDUNG'"
      [referenzObjectId]="geschaeft.timePoint.id?.id"
      [timepointId]="geschaeft.timePoint.id">
    </cap-vertragsdaten>
    <cap-list-loader [listLoader]="grundstueckloader" [showTotal]="true" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        @for (grundstueck of grundstueckloader?.items; track grundstueck) {
          <div class="title-divider mt-4 row rubrik-divider">
            <h3 class="mb-1 mt-0 rubrik-title">
              <cap-kompakt-grundstueck [item]="grundstueck"></cap-kompakt-grundstueck>
            </h3>
            @if (grundstueck.histInfo.bisTimePoint?.id.id === geschaeft.id.id) {
              <h3 class="ms-5 red fw-bold">{{ "(MitDiesemGeschäftGeschlossen)" | translate }}</h3>
            }
          </div>
          <cap-meldungsrelevante-grundstuecke [grundstueckId]="grundstueck.id"></cap-meldungsrelevante-grundstuecke>
        }
      </div>
    </cap-list-loader>
    <div class="title-divider mt-4 mb-2 row rubrik-divider">
      <h3 class="mb-1 mt-0 rubrik-title">{{ "Servitute" | translate }}</h3>
    </div>
    <cap-standardrecht-table
      [customSort]="servitutSortFunction"
      [formatKopfzeile]="formatKopfzeileEnum.GRUNDSTUECK"
      [listLoader]="dienstbarkeitenLoader"
      [showGehoertZu]="false"
      [showNachgang]="false"
      [showVertragtext]="false">
    </cap-standardrecht-table>
    <div class="title-divider mt-4 mb-2 row rubrik-divider">
      <h3 class="mb-1 mt-0 rubrik-title">{{ "Anmerkungen" | translate }}</h3>
    </div>
    <cap-standardrecht-table
      [customSort]="servitutSortFunction"
      [formatKopfzeile]="formatKopfzeileEnum.GRUNDSTUECK"
      [listLoader]="anmerkungenLoader"
      [showGehoertZu]="false"
      [showNachgang]="false"
      [showVertragtext]="false">
    </cap-standardrecht-table>
  </div>
} @else {
  <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
}
